import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { catchError, of, tap } from "rxjs";
import { AnimalService } from "src/app/services/animal.service";
import { Company } from "src/app/models/company.model";
import { CompanyService } from "src/app/services/company.service";
import { ExternService } from "src/app/services/extern.service";

@Component({
    selector: 'app-search-company',
    templateUrl: './search-company.component.html',
    styleUrls: ['./search-company.component.scss'],
    standalone: false
})
export class SearchCompanyComponent implements OnInit {

    public loading = false;
    public errorText = '';
    public chooseCompany: Company | null = null;
    public keyword: string = '';
    public companies: Company[] = [];
    public companiesToFilter: number[] = [];

    constructor(
        protected dialogRef: NbDialogRef<SearchCompanyComponent>,
        protected externService: ExternService,
        protected companyService: CompanyService
    ) { }

    ngOnInit(): void {

    }

    searchAction(): void {

        if (this.keyword.length > 0) {

            this.companyService.search(this.keyword, 1, 25).subscribe(
                items => {
                    this.companies = items.companies.filter((element: Company) => (this.companiesToFilter.indexOf(element.id) == -1));
                }
            );

        } else {
            this.companies = [];
        }
    }

    chooseAction(group: Company | null): void {

        this.chooseCompany = group;
        if (group) {
            this.keyword = '';
            this.companies = [];
        }
    }

    saveAction(): void {

        this.loading = true;
        if (!this.chooseCompany) return;
        this.dialogRef.close({ id: this.chooseCompany.id });
    }

    closeAction(): void {
        this.dialogRef.close();
    }
}